import { Container, Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerButton from '../../../components/Button/SpinnerButton';
import { authFetch } from '../../../utils/apiClient.js';
import { useState, useRef } from 'react';
import useUserStore from '../../../stores/userStore.js';
import { RiFileCopyFill } from '@remixicon/react';
import { handleCopyToClipboard } from '../../../utils/helpers.js';
import Copied from '../../../components/Copied/Copied.jsx';

export default function AffiliationsScreen() {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const { affiliateId } = useUserStore();
    const timerRef = useRef(null);
    const [showCopiedModal, setShowCopiedModal] = useState(false);

    const handleGenerateAffiliateLink = async () => {
        setIsLoading(true);

        await authFetch('/api/affiliates/create', {
            method: 'POST'
        });

        setIsLoading(false);
    }

    const getAffiliateUrl = () => {
        return `${window.location.origin}/pricing?ref=${affiliateId}`;
    }

    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col xs={12} className="text-center">
                    <h2 className="title mb-2">{t('affiliations.title')}</h2>
                    <p className="subtitle">{t('affiliations.subtitle')}</p>
                </Col>
            </Row>

            <Card>
                <Card.Body>
                    <Row className="mb-4 g-4">
                        <Col xs={12} md={6}>
                            <h3 className="card-title mb-3">{t('affiliations.affiliateLink')}</h3>
                            {affiliateId === null ? (
                                <SpinnerButton
                                    isLoading={isLoading}
                                    className="bg-pink w-100"
                                    onClick={handleGenerateAffiliateLink}
                                    label={t('affiliations.generateMyAffiliateLink')}
                                />
                            ) : (
                                <div className="d-flex align-items-center">
                                    <span className="me-2">{t('affiliations.copyLink')}</span>
                                    <RiFileCopyFill
                                        onClick={() => handleCopyToClipboard(getAffiliateUrl(), timerRef, setShowCopiedModal)}
                                        size={20}
                                        role="button"
                                        className={`copy-icon`}
                                        title={t('affiliations.copyLink')}
                                    />
                                </div>
                            )}

                        </Col>
                        <Col xs={12} md={6}>
                            <h3 className="card-title mb-3">{t('affiliations.affiliationCompleted')}</h3>
                            <p className="card-text">0</p>
                        </Col>
                    </Row>

                    <Row className="mb-4 g-4">
                        <Col xs={12} md={6}>
                            <h3 className="card-title mb-3">{t('affiliations.earningsThisMonth')}</h3>
                            <p className="card-text">0€</p>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Copied
                show={showCopiedModal}
                onHide={() => setShowCopiedModal(false)}
            />
        </Container >
    );
}
